import { useMe } from '@/lib/useMe';
import { standingMessage } from '@/lib/siteStanding';

/** This site's billing standing, from the fourteen-day notice onward. The API
 *  sends it to an Owner or Admin only, so no role check is repeated here. */
export function SiteStandingBanner() {
  const me = useMe();
  const standing = me.data?.site_standing;
  if (!standing) return null;
  return (
    <div
      role="status"
      className="bg-tres-warning px-4 py-1.5 text-center text-xs font-semibold text-white"
    >
      {standingMessage(standing)}
    </div>
  );
}
